import { useEffect, type RefObject } from 'react';

/**
 * Hook to inject inline styles into a container element.
 * Similar to ShadowElement.addStyles() but for React components.
 * 
 * @param containerRef - Ref to the container element where inline styles will be injected
 * @param styles - Optional CSS string to inject
 */
export function useAddStyles(
	containerRef: RefObject<HTMLElement>,
	styles?: string
) {
	// Inject inline styles
	useEffect(() => {
		if (!styles || !containerRef.current) return;

		const styleEl = document.createElement('style');
		styleEl.innerHTML = styles;
		containerRef.current.appendChild(styleEl);

		return () => {
			if (styleEl.parentNode) {
				styleEl.parentNode.removeChild(styleEl);
			}
		};
	}, [containerRef, styles]);
}
